"use strict";
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable @typescript-eslint/no-empty-interface */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorType = void 0;
var BehaviorType;
(function (BehaviorType) {
    BehaviorType["Trainer"] = "trainer";
    BehaviorType["Vendor"] = "vendor";
    BehaviorType["Crier"] = "crier";
    BehaviorType["Peddler"] = "peddler";
    BehaviorType["Identifier"] = "identifier";
    BehaviorType["Tanner"] = "tanner";
    BehaviorType["Culinarian"] = "culinarian";
    BehaviorType["Alchemist"] = "alchemist";
    BehaviorType["Smith"] = "smith";
    BehaviorType["Encruster"] = "encruster";
    BehaviorType["Banker"] = "banker";
    BehaviorType["Steelrose"] = "steelrose";
    BehaviorType["Succorer"] = "succorer";
    BehaviorType["Upgrader"] = "upgrader";
    BehaviorType["Magician"] = "magician";
    BehaviorType["HallOfHeroes"] = "hallofheroes";
    BehaviorType["HPDoc"] = "hpdoc";
    BehaviorType["MPDoc"] = "mpdoc";
    BehaviorType["Binder"] = "binder";
    BehaviorType["ItemModder"] = "itemmodder";
    BehaviorType["Cosmetic"] = "cosmetic";
    BehaviorType["Buffer"] = "buffer";
    BehaviorType["Resetter"] = "resetter";
    BehaviorType["AXPSwapper"] = "axpswapper";
    BehaviorType["FurUpgrader"] = "furupgrader";
    BehaviorType["Guildmaster"] = "guildmaster";
    BehaviorType["GuildClerk"] = "guildclerk";
    BehaviorType["ExitWarper"] = "exitwarper";
    BehaviorType["SpoilerLogger"] = "spoilerlogger";
    BehaviorType["RNGArtificer"] = "rngartificer";
    BehaviorType["TreasureClaimer"] = "treasureclaimer";
    BehaviorType["EventPlanner"] = "eventplanner";
    BehaviorType["TrinketManager"] = "trinketmanager";
    BehaviorType["HalloweenCandy"] = "halloweencandy";
    BehaviorType["ThanksgivingFood"] = "thanksgivingfood";
    BehaviorType["ThanksgivingGuns"] = "thanksgivingguns";
    BehaviorType["ThanksgivingTurkey"] = "thanksgivingturkey";
    BehaviorType["ChristmasSanta"] = "christmassanta";
})(BehaviorType || (exports.BehaviorType = BehaviorType = {}));
